import { NavItem, Skill, Project, ContactMethod } from '../types';

// Navigation Items
export const NAV_ITEMS: NavItem[] = [
    { label: 'Home', href: '#home' },
    { label: 'Profile', href: '#profile' },
    { label: 'Skills', href: '#skills' },
    { label: 'Works', href: '#works' },
    { label: 'Contact', href: '#contact' },
];

// Hero Content
export const HERO_CONTENT = {
    name: 'Yutaro Mizuno',
    nameJp: '水野 悠太郎',
    age: 21,
    backgroundImage: '/images/hero-bg.webp',
};

// Profile Content
export const PROFILE_CONTENT = {
    name: ' 水野 悠太郎',
    nameEn: 'Yutaro Mizuno',
    location: '神奈川県横浜市出身。',
    mainDescription: `SNSやメタバース、アプリ開発など、ユーザーが楽しく使えるサービスづくりに関わってきました。
趣味の延長で運営しているSNSでは運営や改善を通じて安定したサービスづくりに取り組み、メタバースでは空間デザインやイベント企画を行い、バーチャルならでは
の面白さを形にしました。ほかにも、Premiere Proでの動画制作や、SwiftUI・Figmaを使ったiOSアプリのUIデザインなど、幅広く携わってきました。。`,
    additionalSkill: 'AppStore にリリースされている VRCi というアプリのデザイン (UI/UX) を担当。',
    futureVision: `今後は、アイデアを具体化する初期段階からチームに参加し「このサービスは誰のために、何の目的で存在するのか？」を共に考えながら、
伝わりやすいコンセプトや使いやすいデザインを作っていけたらと考えています。`,
};

// Skills Data
export const SKILLS_DATA: Skill[] = [
    {
        category: 'Design',
        title: 'Design',
        description: `Photoshop、Illustratorなどを用いて
グラフィックデザインやロゴなどを制作します。
また、FigmaやAdobe XDなどで柔軟かつテーマ性を保ったデザインを作ることも可能です。`,
        tools: ['Photoshop', 'Illustrator', 'Figma', 'Adobe XD'],
    },
    {
        category: 'Website',
        title: 'Website',
        description: `SNSを運営するサークル「桜ヶ丘電信」にてインスタンスの
立ち上げから運用までを行っており、
Linuxサーバーの基本的な使い方からHTML / CSSによるUIカスタマイズや
Gitでのソース管理を経験しました。`,
        tools: ['Linux', 'HTML/CSS', 'Git', 'Server Management'],
    },
    {
        category: 'Other',
        title: 'Other',
        description: `メタバースプラットフォームのワールドの設計、オンラインコミュニティのマネジメント、メタバース・リアルイベントの接客・運営、動画制作など`,
        tools: ['Unity', 'Blender', 'Premiere Pro', 'Community Management'],
    },
];

// Projects Data
export const PROJECTS_DATA: Project[] = [
    {
        id: 'vrci',
        title: 'VRCi',
        titleJp: 'VRCi',
        description: `Unofficial third-party companion application for VRChat® for iOS with SwiftUI`,
        descriptionJp: `iOS向けVRChat®の非公式サードパーティコンパニオンアプリケーション。

SwiftUIを使用したモダンなUI/UXデザインを担当。

操作性や使いやすさを意識した設計を重視し、より快適な体験づくりを目指しました。`,
        technologies: ['SwiftUI', 'UI/UX Design', 'iOS', 'Figma'],
        appStore: 'https://apps.apple.com/jp/app/vrci/id6746643250',
        github: 'https://github.com/VRCiOS/VRCi',
        image: '/images/vrci/vrci-mockup.png',
        featured: true,
    },
    {
        id: 'xrcc',
        title: 'MPUF XRCC',
        titleJp: 'MPUF XRCC',
        description: `XRCCとは、バーチャル空間においてリアルタイムに交流できる、インタラクティブなイベントやセミナーをWEB上で手軽に実施・参加できるXRクラウドサービスです。`,
        descriptionJp: `MPUF（Microsoft Project User Forum）にて、Webベースのメタバースプラットフォーム「XRCC（XR Conference Cloud）」の開発・運営に携わりました。

UX視点での空間設計や、Unity・Blenderを活用したワールドのプロトタイプ制作、Webブラウザで動作するメタバース空間のUIデザインなど、幅広く担当。ユーザーが直感的に楽しめる体験づくりを意識して取り組みました。

また、ニコニコ超会議などの大型イベントでは、XRCCのキャラクター「Chicoちゃん」を活用したVtuber型の接客パフォーマンスを実施。声優によるリモート操作とリアルタイム対話システムを組み合わせ、会場の大型モニター越しに来場者と交流するなど、メタバースとリアル空間がつながる新しい体験づくりを支援しました。

この取り組みを通じて、同ブースで展示していた京都の伝統工芸品の認知向上・販促にも貢献しています。

さらに、メタバース空間内でのイベント企画や運営、広報用の動画制作なども幅広くサポートし、プラットフォーム全体の活性化に取り組みました。`,
        technologies: ['Unity', 'Blender', '3D Design', 'XR'],
        images: [
            '/images/xrcc/142XRCCtayoEXPO2023MPUF-YouTube1.jpg',
            '/images/xrcc/2025-04-1722.54.20.jpg',
            '/images/xrcc/2025-04-1722.50.53.jpg',
            '/images/xrcc/2025-04-1722.48.47.jpg',
            '/images/xrcc/142XRCCtayoEXPO2023MPUF-YouTube.jpg',
            '/images/xrcc/142XRCCtayoEXPO2023MPUF-YouTube.png',
            '/images/xrcc/142XRCCVTuber-YouTube.png',
        ],
        featured: true,
    },
    {
        id: 'sakuragaoka',
        title: '桜ヶ丘電信',
        titleJp: '桜ヶ丘電信',
        description: `MisskeyやMastodonを活用したSNSの企画・運営を行う自主サークルにて、複数のSNSを立ち上げ・運営しています。`,
        descriptionJp: `趣味の延長からSNSプラットフォームの立ち上げ・運営・管理を行い、UI/UX改善やカスタマイズを通じて、安定したサービス運営とユーザー満足度の向上に取り組みました。

また、運営負担の分散と管理体制の強化を目的にSNS運営サークル「桜ヶ丘電信」を立ち上げ、役割分担や運用ルールを整備。複数人による共同管理体制を構築し、持続可能な運営を実現しました。

利用者からのフィードバックをもとに改善を重ね、トラブル未然防止や安定稼働にも貢献しています。`,
        technologies: ['Mastodon', 'Misskey', 'Linux', 'UI/UX'],
        images: [
            '/images/sakuragaoka/2025-04-188.21.12.png',
            '/images/sakuragaoka/2025-04-188.17.20.png',
        ],
    },
    {
        id: 'video',
        title: '動画制作',
        titleJp: '動画制作',
        description: `こちらのYouTubeチャンネルにて、動画制作の一部を担当しました。`,
        descriptionJp: `動画を作るうえで必要な情報収集と台本作成、Premiere Proを用いた編集作業を行い、内容の信頼性と視聴者への分かりやすさに配慮した動画作りを行いました。

YouTube以外にも、広報用動画の編集経験があります。`,
        technologies: ['Premiere Pro', 'After Effects', 'Motion Design'],
        youtube: 'https://youtu.be/CyNgPz_htH8?si=GmxzYY3tj3dLMDWY',
    },
];

// Contact Information
export const CONTACT_INFO: ContactMethod[] = [
    {
        platform: 'Mail',
        value: 'magical.shrub0o@icloud.com',
        link: 'mailto:magical.shrub0o@icloud.com',
    },
    {
        platform: 'Discord',
        value: 'minemu',
    },
];